import amazonDemoConfig from './amazon-demo.config'
import sageHomeLoansConfig from './sage-home-loans.config'

export default {
  amazon: amazonDemoConfig,
  'sage-home-loans': sageHomeLoansConfig,
}
